import classify from "@views/classify/classify";
import search from "@views/classify/search";
import goodsDetail from "@views/classify/goodsDetail";
import goods from "@views/classify/goods";
import evaluate from "@views/classify/evaluate";
import detail from "@views/classify/detail";
import parameter from "@views/classify/parameter";
import goodsDiy from "@views/classify/goodsDiy";

const classifyRouter = [
  {
    path: "classify",
    name: "classify",
    // component: classify,
    component: (resolve) => require(["@views/classify/classify"], resolve),
    meta: {
      title: "品牌分类",
      id: "2",
    },
  },
  {
    path: "search",
    name: "search",
    // component: search
    component: (resolve) => require(["@views/classify/search"], resolve),
  },
  {
    path: "goodsDetail",
    // component: goodsDetail,
    component: (resolve) => require(["@views/classify/goodsDetail"], resolve),
    children: [
      {
        path: "",
        name: "goods",
        // component: goods,
        component: (resolve) => require(["@views/classify/goods"], resolve),
        meta: {
          id: 0,
        },
      },
      {
        path: "detail",
        name: "detail",
        // component: detail,
        component: (resolve) => require(["@views/classify/detail"], resolve),
        meta: {
          id: 1,
        },
      },
      {
        path: "parameter",
        name: "parameter",
        // component: parameter,
        component: (resolve) => require(["@views/classify/parameter"], resolve),
        meta: {
          id: 2,
        },
      },
      {
        path: "evaluate",
        name: "evaluate",
        // component: evaluate,
        component: (resolve) => require(["@views/classify/evaluate"], resolve),
        meta: {
          id: 3,
        },
      },
      {
        path: "goodsDiy",
        name: "goodsDiy",
        // component: goodsDiy,
        component: (resolve) => require(["@views/classify/goodsDiy"], resolve),
        meta: {
          id: -1,
        },
      },
    ],
  },
  {
    path: "diyPage",
    name: "diyPage",
    // component: goodsDiy,
    title: "美心门产品展示",
    component: (resolve) => require(["@views/classify/diyPage"], resolve),
    meta: {
      id: -1,
      title: "美心门产品展示",
    },
  },
];

export default classifyRouter;



// WEBPACK FOOTER //
// ./src/router/classify/index.js